import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: grid;
	grid-template-columns: 1fr 41%;
	grid-template-rows: auto auto auto 1fr;
	grid-gap: var(--gap);
	padding-bottom: var(--gap);
	flex: 1;

	.half-row {
		grid-column: span 1;
	}

	.full-row {
		grid-column: span 2;
	}

	.motif-tab-navigation {
		align-self: baseline;
	}
`;
